import * as api from '../api';
import * as MutationTypes from '../mutationTypes';
import { GroupOfProductPricing } from '../models';

export const groupOfProductPricingListRequest = async ({
  commit,
  getters: { groupOfProductPricingList }
}, pointOfSaleGuid) => {
  if (groupOfProductPricingList.length === 0) {
    const response = await api.groupOfProductPricingListRequest(pointOfSaleGuid);
    const groups = GroupOfProductPricing.toInstanceList(response.data);
    commit(MutationTypes.GROUP_OF_PRODUCT_PRICING_LIST_SUCCESS, groups);
    return groups;
  }
  return groupOfProductPricingList;
};
